import { Ptag } from "../../../components/fonts";
import React from "react";
import styled from "styled-components";
import { colors } from "../../../theme";

function TextInline({ name }) {
  return (
    <TpaName>
      <Ptag fontWeight="500" fontSize="16px">
        {name}
      </Ptag>
    </TpaName>
  );
}

export default TextInline;

const TpaName = styled.div`
  height: 64px;
  background-color: ${colors.newCardBgColor};
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 20px;
`;
